import { defineStore } from "pinia";

export const useTopBarStore = defineStore("topBar", {
	state: () => ({
		// Forward/back arrow navigation
		canGoBack: false,
		canGoForward: false,
		hideFpsCounter: true,

		// Sheet menu state
		isSheetMenuOpen: false,

		hideSideNav: false,
	}),
	actions: {
		editorMenuItemClicked(id: string) {
			switch (id) {
				case "toggle-fps-counter":
					this.hideFpsCounter = !this.hideFpsCounter;
					break;
			}
			// This is intentionally left empty...
			// Use store.$onAction within your component to listen for this action
			// More info at: https://pinia.vuejs.org/core-concepts/actions.html#Subscribing-to-actions
		},
		toggleSideNav() {
			this.hideSideNav = !this.hideSideNav;
		},
	},
});
